module.exports = __webpack_public_path__ + "img/grasse_6.bdb976a7.png";